import * as React from "react";
import Slider from "react-slick";
import moment from "moment";
import { PropertyDetails } from "../../../core/api/models/project";
import { convertPascalCaseToWords } from "../../../core";
import BlankProPic from "../../../styles/images/no-user-sm.png";
import PhoneNumberCopy from "../../../components/phoneNumberCopy/PhoneNumberCopy";
import EmailLink from "../../../components/emailLink/EmailLink";

interface IFinanceInformationProps {
  templates: any;
  index: number;
  propertyDetails?: PropertyDetails[];
  onRemove: (propertys: PropertyDetails[]) => void;
  onSelect: () => void;
}

const Propertynformation: React.FunctionComponent<IFinanceInformationProps> = (
  props
) => {
  const [propDropdown, setPropDropdown] = React.useState<number | null>(null);
  const settings = {
    className: "require-slider",
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
  };
  const [dropPos, setDropPos] = React.useState<{
    open: boolean;
    x: string;
    y: string;
    id: string;
    fieldName: string;
}>();


const dropdownClick = (event: any, id: string, fieldName: string) => {
  const pos = event.target.getBoundingClientRect();
  const x = pos.x + "px";
  const y = pos.y + pos.height + "px";
  setDropPos({ open: !dropPos?.open, x, y, id, fieldName });
};

const renderFieldDetails = (fieldName: string, fieldArrayValues: any) => {
return (
  <div
      className="position-absolute bg-white shadow w-100 pt-2"
      style={{ right: 0 , maxWidth: "435px", zIndex: 100 }}
  >
      <div className="px-3 pt-2 font-normal text-gray-600 font-weight-semibold my-1">
          {fieldName}
      </div>
      {fieldArrayValues?.map((itemData: any, index: number) => {
          return (
              <div className="d-flex align-items-center text-nowrap py-2 px-3 border-bottom" key={index}>
                  <img
                      src={itemData?.profileImage ? itemData?.profileImage : BlankProPic}
                      alt="image_not_found"
                      className="img-cover rounded-circle img-responsive mr-2"
                      width={26}
                      height={26}
                  />
                  <div className="font-weight-semibold">
                      <div className="font-normal">
                          {itemData.contactName}
                      </div>
                      <div className="font-xs text-gray-600 d-flex align-items-center">
                      {item.phones.map((itm:any, idx:number)=><><PhoneNumberCopy>{itm.phone}</PhoneNumberCopy>{++idx < item?.phones?.length ? ', ' : '' }</>)}
                      </div>
                      <div className="font-xs text-gray-600 d-flex align-items-center">
                          {itemData.emails.map((itm:any, idx:number)=><><EmailLink>{itm.email}</EmailLink>{++idx < itemData.emails.length ? ', ' : ''}</>)}
                      </div>
                      <div className="font-xs text-gray-600 d-flex align-items-center">
                          {itemData?.type}
                      </div>
                  </div>
              </div>
          );
      })}
  </div>
);  
  
};
  const item = props.templates?.[0];

  const totalArea =
    props.templates?.reduce((t: any, c: any) => t + Number(c.area || 0), 0) ||
    0;

  const unitDetails = props.templates;

  const floors = [...new Set(unitDetails?.map((f: any) => f.floor))].sort();

  const ordinalSuffixOf = (i: number) => {
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "st";
    }
    if (j === 2 && k !== 12) {
      return i + "nd";
    }
    if (j === 3 && k !== 13) {
      return i + "rd";
    }
    return i + "th";
  };

  const onAllSelected = (projectId: string) => {
    const currentShortList = props.propertyDetails?.filter(
      (x) => x.projectId !== projectId?.toString()
    );
    props.onRemove(currentShortList!);
  };

  const onSelect = (propertyId: string) => {
    const currentShortList = props.propertyDetails?.filter(
      (x) => x.propertyId !== propertyId?.toString()
    );
    props.onRemove(currentShortList!);
  };

  const renderDetails = () => {
    return (
      <>
        <tr
          className={`require-row ${
            propDropdown === props.index ? "active" : ""
          }`}
        >
          <td
            className="py-2 border-bottom pr-0"
            style={{ maxWidth: "80px", minWidth: "40px", width: "70px"}}
          >
            <div className="py-1">
              <i
                className="icon-arrange text-gray-400 cursor-pointer"
                style={{ fontSize: "8px" }}
                onClick={(e) => onAllSelected(item.projectId)}
              ></i>
              <span className="font-sm ml-3 font-weight-semibold">
                {props.index + 1}
              </span>
            </div>
          </td>
          <td
            className="py-2 border-bottom"
            style={{ maxWidth: "90px", minWidth: "90px", width:"90px" }}
          >
            <div className="py-1 text-center">
              {
                item?.propertyCoverImage ? ( <img
                  src={item?.propertyCoverImage}
                  alt={item?.projectName}
                  width={59}
                  height={45}
                  className="img-cover"
                />) : (<div className="d-flex align-items-center justify-content-center" style={{width: '59px', height: '45px', backgroundColor: '#f3eded', fontSize: '10px', fontWeight: 500, color: 'black' }}>No Image</div>)
               }
            </div>
          </td>
          <td
            className="pl-0 pr-3 border-bottom"
            style={{ minWidth: "290px", maxWidth: "290px", width:"290px" }}
          >
            <div className="py-1 w-100">
              <div className="font-sm text-truncate mb-1 text-wrap">
                {item?.projectName}
              </div>
              <div className="font-xs text-gray-500 line-clamp-2 text-wrap">
                {item?.propertyAddress}
              </div>
            </div>
          </td>
          <td
            className="pl-0 pr-3 border-bottom px-2 text-left"
            style={{ minWidth: "194px", maxWidth: "194px", width:"194px" }}
          >
            {!!item?.requirementVersion && (
              <div className="py-1 font-sm">
                V{item?.requirementVersion || 0}
              </div>
            )}
          </td>
          <td
            className="pl-0 pr-3 border-bottom px-2 text-left"
            style={{ minWidth: "120px", maxWidth: "120px", width:"120px" }}
          >
            <div className="pl-0 pr-3 font-xs text-gray-800">
              <b>{totalArea}</b> /Sq. Ft
            </div>
          </td>
          <td
            className="pl-0 pr-3 border-bottom px-2 text-left"
            style={{ minWidth: "200px", maxWidth: "200px", width:"200px" }}
          >
            <div className="py-1 font-xs text-gray-800 font-weight-semibold text-wrap">
              {item?.developer}
            </div>
          </td>

          <td className="pl-0 pr-3 border-bottom px-2 text-left">
            <div className="py-1">
              <div className="font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2">
                Floor: {props.templates?.[0]?.floor} / Unit:{" "}
                {props.templates?.[0]?.unitName} / Area:{" "}
                {props.templates?.[0]?.area}
              </div>
              {props.templates?.length > 1 && (
                <div className="font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2">
                  +{props.templates?.length - 1}
                </div>
              )}
            </div>
          </td>
          <td className="pl-0 pr-3 border-bottom px-2 text-left">
            <div
              className="py-1 cursor-pointer"
              onClick={() =>
                propDropdown === props.index
                  ? setPropDropdown(null)
                  : setPropDropdown(props.index)
              }
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="chevron-down (98) 1">
                  <path
                    id="Vector"
                    d="M6 9L12 15L18 9"
                    stroke="#272B2A"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            </div>
          </td>
        </tr>
        {propDropdown === props.index && (
          <tr>
            <td colSpan={8} className="pl-0 pr-0">
              <div className="py-4 pr-4 pl-5" style={{ maxWidth: "90vw" }}>
                <Slider {...settings} arrows={floors?.length >= 6}>
                  <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                    <div className="font-sm font-weight-semibold title">
                      Matching Unit
                    </div>
                    <div className="font-xs font-weight-medium text-gray-700">
                      {
                        unitDetails?.filter(
                          (p: any) => p.currentStatus === "available"
                        )?.length
                      }{" "}
                      Available, {unitDetails?.length} Total
                    </div>
                  </div>
                  {floors?.map((fl) => {
                    const availableCount = unitDetails?.filter(
                      (x: any) =>
                        x.currentStatus === "available" && x.floor === fl
                    )?.length;
                    const totalCount = unitDetails?.filter(
                      (x: any) => x.floor === fl
                    )?.length;

                    return (
                      <>
                        <div className="border rounded p-2 d-inline-block mr-1 w-auto">
                          {fl === "0" ? (
                            <div className="font-sm font-weight-semibold title">
                              Ground Floor
                            </div>
                          ) : (
                            <div className="font-sm font-weight-semibold title">
                              {ordinalSuffixOf(Number(fl))} Floor
                            </div>
                          )}
                          <div className="font-xs font-weight-medium text-gray-700">
                            {availableCount} Available, {totalCount} Total
                          </div>
                        </div>
                      </>
                    );
                  })}
                </Slider>
              </div>
              <div>
                <table className="table table-bordered w-100 font-sm">
                  <tr>
                    <td
                      className="py-2  px-2   border-bottom px-1"
                      style={{ maxWidth: "40px", width: "40px" }}
                    >
                      <div className="">
                        <i
                          className="icon-close cursor-pointer"
                          onClick={(e) => onAllSelected(item.projectId)}
                        ></i>
                        <label
                          htmlFor={`propertyCheck- px-2 -${item.projectId}`}
                        ></label>
                      </div>
                    </td>
                    <td className="py-2 border-bottom">
                      <div className="py-1">Floor</div>
                    </td>
                    <td className="py-2 border-bottom">
                      <div className="py-1">Unit Id</div>
                    </td>
                    <td className="py-2 border-bottom">
                      <div className="py-1">Area (in Sq.Ft)</div>
                    </td>
                    <td className="py-2 border-bottom">
                      <div className="py-1">Interior Type</div>
                    </td>
                    <td className="py-2 border-bottom">
                      <div className="py-1">Quoted Rent</div>
                    </td>
                    <td className="py-2 border-bottom">
                      <div className="py-1">Current Status</div>
                    </td>
                    <td className="py-2 border-bottom">
                      <div className="py-1">Available From</div>
                    </td>
                    <td className="py-2 border-bottom font-sm">
                      <div className="py-1">Contact Details</div>
                    </td>
                  </tr>
                  {unitDetails?.map((unit: any) => {
                    const property = unit;
                    const propertyDetails =unit?.propertyDetails
                    return (
                      <>
                        <tr>
                          <td
                            className="py-3 px-2 border-bottom px-0"
                            style={{
                              maxWidth: "40px",
                              width: "40px",
                            }}
                          >
                            <div className="">
                              <i
                                className="icon-close cursor-pointer"
                                onClick={(e) => onSelect(property?.propertyId)}
                              ></i>

                              <label
                                htmlFor={`propertyCheck-${unit.projectId}-${property?.propertyId}`}
                              ></label>
                            </div>
                          </td>
                          <td className="py-3 border-bottom">
                            <div className="">{property.floor}</div>
                          </td>
                          <td className="py-3 border-bottom">
                            <div className="">{property.unitName}</div>
                          </td>
                          <td className="py-3 border-bottom">
                            <div className="">{property.area}</div>
                          </td>
                          <td className="py-3 border-bottom">
                            <div className="">{property?.interiorType}</div>
                          </td>
                          <td className="py-3 border-bottom">
                            <div className="">{property?.quotedRent} </div>
                          </td>
                          <td className="py-3 border-bottom">
                            <div className="">
                              {convertPascalCaseToWords(
                                property?.currentStatus
                              )}
                            </div>
                          </td>
                          <td className="py-3 border-bottom">
                            {property?.availableFrom &&
                              property?.availableFrom !==
                                "1970-01-01T00:00:00.000Z" && (
                                <div className="">
                                  {moment(property?.availableFrom).format(
                                    "DD-MM-YYYY"
                                  )}
                                </div>
                              )}
                          </td>
                          <td
                                       className="py-2 border-bottom"
                                        style={{ width: "290px", maxWidth: "290px" }}
                                        >
                                            <div role="button" className="py-1 w-100 font-xs font-weight-semibold position-relative"
                                             onClick={(e) => dropdownClick(e, propertyDetails?._id, 'ContactDetails')}
                                             >
                                                { propertyDetails?.contactDetails?.length
                                                        ? propertyDetails?.contactDetails?.length > 2
                                                            ? propertyDetails.contactDetails
                                                                .slice(0, 2)
                                                                .map((participant: any) =>
                                                                    participant
                                                                        ? `${participant.contactName || ''}`
                                                                        : ''
                                                                )
                                                                .join(", ")
                                                            : propertyDetails?.contactDetails?.map((participant: any) =>
                                                                participant
                                                                    ? `${participant.contactName || ''}`
                                                                    : ''
                                                            )
                                                                .join(", ")
                                                        : ""}
                                                <span
                                                    className="text-primary cursor-pointer"
                                                   
                                                >
                                                    {propertyDetails?.contactDetails?.length > 2 ? ` +${propertyDetails?.contactDetails?.length - 2}` : ''}
                                                    {!!propertyDetails?.contactDetails?.length && propertyDetails?._id === dropPos?.id && dropPos?.fieldName === 'ContactDetails' &&
                                                         dropPos?.open && (
                                                            renderFieldDetails('Contact Details', propertyDetails?.contactDetails)
                                                        )}
                                                </span>
                                            </div>
                                        </td>
                        </tr>
                      </>
                    );
                  })}
                </table>
              </div>
            </td>
          </tr>
        )}
      </>
    );
  };

  return <>{renderDetails()}</>;
};

export default Propertynformation;
